import { UserAttributeDefs } from "@iotv/datamodel-core";
import { Position, ValidBusinessObject } from "@iotv/iotv-v3-types";
import { Storage as V020Storage } from "./Storage";

const typeName = "EffluentSump";

export type EffluentSumpProps = {
  purpose?: string;
  capacity?: number;
  current_filled_volume?: number;
  last_filled_volume?: number;
  current_height?: number;
  diameter?: number;
  depth?: number;
  // shape?: TankShape;
  surfaceWidth?: number;
  bottomWidth?: number;
  length?: number;
  constructionMaterial?: string;
  location?: Position;
  total_volume?: number;
  image?: string;
};

export class EffluentSump extends V020Storage {
  constructor(ob: ValidBusinessObject) {
    super({ ...ob, typeName });
    this.currentVolume = ob.current_filled_volume;
  }

  purpose?: string;
  capacity?: number;
  current_filled_volume?: number;
  last_filled_volume?: number;
  diameter?: number;
  mountHeight?: number;
  depth?: number;
  current_height?: number;
  // shape?: TankShape;
  surfaceWidth?: number;
  bottomWidth?: number;
  length?: number;
  constructionMaterial?: string;
  location?: Position;
  total_volume?: number;
  // image?: string;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: "String",
        editable: true,
        label: "Name",
        name: "name",
        description: "Name of Effluent Pond",
        required: true,
      },
      purpose: {
        type: "String",
        editable: true,
        label: "Purpose",
        name: "purpose",
        description: "Used for",
      },
      // capacity: {
      //   type: 'Number',
      //   editable: true,
      //   label: 'Capacity',
      //   name: 'capacity',
      //   description: 'Total storage capacity of Effluent Pond in m3 and litres',
      // },
      last_filled_volume: {
        type: "Number",
        editable: false,
        label: "Last Filled Volume",
        name: "last_filled_volume",
        description: "The last volume in the pond",
      },
      current_height: {
        type: "Number",
        editable: false,
        label: "Current Height",
        name: "current_height",
        description: "The current Height in the pond",
      },
      // current_filled_volume: {
      //   type: "Number",
      //   editable: false,
      //   label: "Current Volume",
      //   name: "currentVolume",
      //   description: "The current volume in the pond",
      // },
      diameter: {
        type: "Number",
        editable: true,
        label: "Diameter",
        name: "diameter",
        description: "Diameter of Effluent Pond - metre.cm",
      },
      depth: {
        type: "Number",
        editable: true,
        label: "Depth/height",
        name: "depth/Height",
        description: "Depth/ Height of Effluent Pond in m.cm",
      },
      mountHeight: {
        type: "Number",
        editable: true,
        label: "Mount Height",
        name: "Mount Height",
        description: "Mount Height of Effluent Pond in m",
      },
      surfaceWidth: {
        type: "Number",
        editable: true,
        label: "Surface Width",
        name: "Surface Width",
        description: "Surface Width if rectangle",
      },
      bottomWidth: {
        type: "Number",
        editable: true,
        label: "Bottom Width",
        name: "Bottom Width",
        description: "Bottom Width if rectangle",
      },
      length: {
        type: "Number",
        editable: true,
        label: "Length ",
        name: "length",
        description: "Length if rectangle",
      },
      constructionMaterial: {
        type: "String",
        editable: true,
        label: "Construction material",
        name: "constructionMaterial",
        description: "Material Effluent Pond is contructed from",
      },
      location: {
        type: "object",
        editable: true,
        label: "Location",
        name: "location",
        description: "Location of  Effluent Pond (lat/ long)",
      },
      // image: {
      //   type: 'String',
      //   editable: true,
      //   label: 'Image',
      //   name: 'image',
      //   description: 'Photograph of Effluent Pond',
      // },
      comments: {
        type: "String",
        editable: true,
        label: "Comments",
        name: "comments",
        description: "Free text for info ",
      },
    };
  }
}
